module.exports = __webpack_public_path__ + "static/media/logo_scitec-media.cc121cb8.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/logo_scitec-media.svg
 ** module id = 369
 ** module chunks = 0
 **/